import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-trending-post',
  standalone: true,
  imports: [CommonModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './trending-post.component.html',
  styleUrls: ['./trending-post.component.scss']
})
export class TrendingPostComponent implements OnInit, OnChanges {
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  commonDatahide:any={}
  @Input('title') title: string = 'Quick reference';
  @Input() inputData: any;
  @Input() page: any;
  @Input() suggestion: any;
  modalRef: BsModalRef;
  headerTitle: string = 'Trending Posts';
  user: any = [{ a: 1 }, { a: 2 }, { a: 3 }, { a: 4 }];
  @Input() widgetDesc: string;
  titleforModel:any;
  modelType:string;
  constructor(private a_route: ActivatedRoute,private router: Router,private modalService: BsModalService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  hide(flag){
    this.commonDatahide.widgetName="TrendingPostComponent";
    this.commonDatahide.hide = flag;
    // Support both EventEmitter (template binding) and callback function (NgComponentOutlet)
    if (typeof this.commonFunction === 'function') {
      this.commonFunction(this.commonDatahide);
    } else if (this.commonFunction?.emit) {
      this.commonFunction.emit(this.commonDatahide);
    }
  }
  
  modelopen(name) {
    let datas:any={};
    datas.menu=name;
    this.router.navigate(['help'], { queryParams: datas });
    // if(name=='job'){
    //   this.titleforModel="How to create your first Job?"
    //   this.modelType='job';
    // }  else if(name=='candidate'){
    //   this.titleforModel="How to create your first Candidate?"
    //   this.modelType='candidate';
    // }
    // this.modalRef = this.modalService.show(template);
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.hide(true)
    this.a_route.queryParams.subscribe((res) => {
      if (res.master && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
    })
  }

}
